
(function (window, document, jQuery, undefined) {

    // map to local vars
    var $ = jQuery.noConflict();
    var $document = $(document);

    // change HREF attributes
    $document.ready(function () {
        var $qiLinks = $('.kit-navbar__item--level-3');
        $qiLinks.each(function () {

            $qiLink = $(this);

            if ($qiLink.attr("href").toLowerCase().endsWith("/de-de/page/home/aerzte-und-praxismitarbeiter/omnicare-qualitaetsinitiative-fuer-praxen")) {
                $qiLink.attr("href", "/de-de/page/home/apotheker-und-apothekenteams/omnicare-qualitaetsinitiative-fuer-apotheken");
            }

            else if ($qiLink.attr("href").toLowerCase().endsWith("/en-US/page/home/aerzte-und-praxismitarbeiter/omnicare-qualitaetsinitiative-fuer-praxen")) {
                $qiLink.attr("href", "/en-us/page/home/apotheker-und-apothekenteams/omnicare-qualitaetsinitiative-fuer-apotheken");
            }

            else if ($qiLink.attr("href").toLowerCase().endsWith("/de-de/page/home/aerzte-und-praxismitarbeiter/omnicampus-fortbildungen")) {
                $qiLink.attr("href", "https://services.omnicare.de/de/");
            }

            else if ($qiLink.attr("href").toLowerCase().endsWith("/en-us/page/home/aerzte-und-praxismitarbeiter/omnicampus-fortbildungen")) {
                $qiLink.attr("href", "https://services.omnicare.de/en/");
            }

            else if ($qiLink.attr("href").toLowerCase().endsWith("/de-de/page/home/aerzte-und-praxismitarbeiter/omnicampus-fortbildungen-(1)")) {
                $qiLink.attr("href", "/de-DE/page/Home/OmniCampus/Aerzte-und-MFA");
            }

            else if ($qiLink.attr("href").toLowerCase().endsWith("/en-us/page/home/aerzte-und-praxismitarbeiter/omnicampus-fortbildungen-(1)")) {
                $qiLink.attr("href", "/en-us/page/Home/OmniCampus/Aerzte-und-MFA");
            }

            else if ($qiLink.attr("href").toLowerCase().endsWith("/de-de/page/home/apotheker-und-apothekenteams/omnicampus-fortbildungen-(1)")) {
                $qiLink.attr("href", "/de-de/page/home/omnicampus/fortbildungen-apotheken-(1)");
            }

            else if ($qiLink.attr("href").toLowerCase().endsWith("/en-us/page/home/apotheker-und-apothekenteams/omnicampus-fortbildungen-(1)")) {
                $qiLink.attr("href", "/en-us/page/home/omnicampus/fortbildungen-apotheken-(1)");
            }

            else if ($qiLink.attr("href").toLowerCase().endsWith("/de-de/page/home/fuer-aerzte/praxiszukunft")) {
                $qiLink.attr("href", "https://don.de/kontakt");
            }

            else if ($qiLink.attr("href").toLowerCase().endsWith("/en-us/page/home/fuer-aerzte/praxiszukunft")) {
                $qiLink.attr("href", "https://don.de/kontakt");
            }

            else if ($qiLink.attr("href").toLowerCase().endsWith("/de-de/page/home/fuer-aerzte/niederlassung")) {
                $qiLink.attr("href", "https://don.de/nachfolge");
            }

            else if ($qiLink.attr("href").toLowerCase().endsWith("/en-us/page/home/fuer-aerzte/niederlassung")) {
                $qiLink.attr("href", "https://don.de/nachfolge");
            }
        });
    });

})(window, document, jQuery);
